import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import { Info } from '@sorare/core/src/atoms/icons/Info';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';
import { DisplayS, LabelL, LabelS } from '@sorare/core/src/atoms/typography';
import { useToggle } from '@sorare/core/src/hooks/useToggle';

const IndexContainer = styled(Vertical).attrs({ center: true, gap: 4 })`
  border: 1px solid var(--c-white);
  border-radius: var(--double-unit);
  padding: var(--unit);
  position: relative;
  isolation: isolate;
  width: calc(var(--unit) * 50);
`;

const InfoContainer = styled(Vertical).attrs({ gap: 4 })`
  position: absolute;
  z-index: 1;
  background-color: var(--c-black);
  border: 1px solid var(--c-white);
  border-radius: var(--double-unit);
  padding: var(--double-unit);

  ul {
    padding-left: var(--double-unit);
  }

  li::before {
    content: '•';
    color: var(--c-white);
    display: inline-block;
    width: var(--unit);
    margin-left: calc(var(--unit) * -1);
  }
`;

const CloseButton = styled(IconButton)`
  position: absolute;
  top: var(--double-unit);
  right: var(--double-unit);
  cursor: pointer;
`;

const TextContainer = styled(Vertical).attrs({ gap: 4 })`
  padding: var(--unit);
`;

export const ProfessionalEqualityIndex = () => {
  const [showInfoBox, toggleInfoBox] = useToggle(false);
  return (
    <IndexContainer>
      <LabelL bold>Professional Equality Index</LabelL>
      <Horizontal center>
        <DisplayS bold>89 / 100</DisplayS>
        <Tooltip title="For 2025 based on 2024 numbers">
          <Info />
        </Tooltip>
      </Horizontal>
      <Button color="transparent" size="small" onClick={toggleInfoBox}>
        Learn more
      </Button>
      {showInfoBox && (
        <InfoContainer onClick={toggleInfoBox}>
          <CloseButton
            onClick={toggleInfoBox}
            icon={faTimes}
            color="tertiary"
          />
          <TextContainer>
            <LabelL bold>Professional equality index</LabelL>
            <LabelS>
              This index measures gender wage disparities in French companies
              with more than 50 employees, based on 5 indicators:
              <ul>
                <li>Pay gaps between women and men</li>
                <li>Pay gaps in individual raises</li>
                <li>
                  The number of employees who were given a raise after their
                  maternity leave
                </li>
                <li>
                  Equality between women and men among the 10 highest wages
                </li>
                <li>
                  Promotion rate gaps (for companies with more than 250
                  employees).
                </li>
              </ul>
              If one indicator cannot be measured, the Index is not applicable.
            </LabelS>
          </TextContainer>
        </InfoContainer>
      )}
    </IndexContainer>
  );
};
